import React from 'react';
import {
    Col, FormGroup, Input, Label,
    Row
} from 'reactstrap';

import {LangController} from "../../../components/tabs/langController";

const BenefitLangs = props => {
    const setDataDefault = (activeLangs, setLangChilds) => {
        const items = activeLangs.map( lang => ({
            id: '',
            lang: { id:lang?.id, name:lang?.name },
            description: '',
        }) )

        setLangChilds(items);
    }

    const getFormulary = (child, index, disableInputs, onInputChange) => <>
        <Row>
            <Col md="12">
                <FormGroup>
                    <Label >Descripcion</Label>
                    <Input type="name" name="description"
                           placeholder="Ingrese descripción"
                           value= { child.description }
                           onChange={e => onInputChange(e, child.lang)}
                           disabled={disableInputs}
                    />
                </FormGroup>
            </Col>
        </Row>
    </>

    return(<LangController
        langs={props.langs}
        setLangs={props.setLangs}
        getFormulary={getFormulary}
        setDataDefault={setDataDefault}
        translatableLangs={props.translatableLangs}
    />)
}

export default BenefitLangs
